/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteProductOrchestration
 */
export interface DeleteProductOrchestration {
    /**
     * 
     * @type {number}
     * @memberof DeleteProductOrchestration
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteProductOrchestration
     */
    productId: number;
}

/**
 * Check if a given object implements the DeleteProductOrchestration interface.
 */
export function instanceOfDeleteProductOrchestration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "productId" in value;

    return isInstance;
}

export function DeleteProductOrchestrationFromJSON(json: any): DeleteProductOrchestration {
    return DeleteProductOrchestrationFromJSONTyped(json, false);
}

export function DeleteProductOrchestrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteProductOrchestration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'productId': json['ProductId'],
    };
}

export function DeleteProductOrchestrationToJSON(value?: DeleteProductOrchestration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'ProductId': value.productId,
    };
}

